import { atom } from 'jotai';

/**
 * True while localStorage chat migration is in progress.
 * Used so multiple callers (e.g. several useQueryUser instances) cannot run
 * migrations concurrently.
 */
export const migrationInFlightAtom = atom<boolean>(false);
